import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BankingSettings } from '../../../classes/models/store/BankingSettings';
import {
  AddStoreBankingSettingsRequest,
  EditStoreBankingSettingsRequest
} from '../../../interfaces/request/StoreRequests';
import { asIsoWeekday } from '../../../classes/enums/DayOfWeek';

/**
 * This service communicates with backend to handle store banking settings data management.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreBankingSettingsService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/stores';

  /**
   * Adds new banking requirements for the store.
   * @param storeId an identifier of a store.
   * @param bankingSettings the days of a week on which banking operations need to be performed.
   */
  addBanking(storeId: string, bankingSettings: BankingSettings) {
    const url = `${this.url}/${storeId}/banking-settings`;
    const request: AddStoreBankingSettingsRequest = {
      date: bankingSettings.startDate,
      bankingDays: bankingSettings.days.map(day => asIsoWeekday(day))
    };
    return this.http.post(url, request);
  }

  /**
   * Edits banking requirements for the store.
   * @param storeId an identifier of a store.
   * @param bankingSettings the days of a week on which banking operations need to be performed.
   */
  editBanking(storeId: string, bankingSettings: BankingSettings) {
    const url = `${this.url}/${storeId}/banking-settings/${bankingSettings.startDate}`;
    const request: EditStoreBankingSettingsRequest = {
      bankingDays: bankingSettings.days.map(day => asIsoWeekday(day))
    };
    return this.http.put(url, request);
  }

  /**
   * Deletes banking requirement for the given store starting from the given date.
   * @param storeId an identifier of a store.
   * @param startDate start date of banking requirement.
   */
  deleteBanking(storeId: string, startDate: string) {
    const url = `${this.url}/${storeId}/banking-settings/${startDate}`;
    return this.http.delete(url);
  }
}
